import Modal from './Modal';
import Header from './Header';
import Footer from './Footer';

export { Header as ModalHeader };
export { Footer as ModalFooter };
export default Modal;
